import { useFeatureFlag } from '@moda/portal-stanchions';

export const useEnableClubModaTreatment = () =>
  useFeatureFlag('enable-club-moda-treatment', [{ default: false }, { if: true, then: true }]);
